import { Link, useLocation } from 'react-router-dom';
import { 
  FaChartBar, 
  FaHome, 
  FaUsers, 
  FaEnvelope, 
  FaCog, 
  FaSignOutAlt,
  FaPlus
} from 'react-icons/fa';
import { getAuth, signOut } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';


export default function AdminSidebar() {
  const location = useLocation();
  const navigate = useNavigate();
  const auth = getAuth();


  function pathMatchRoute(route) {
    return route === location.pathname;
  }


  async function onLogout() {
    try {
      await signOut(auth);
      toast.success('Logged out successfully');
      navigate('/');
    } catch (error) {
      toast.error('Error logging out');
    }
  }


  return (
    <div className="w-64 bg-gray-900 text-white min-h-screen fixed left-0 top-0">
      {/* Logo */}
      <div className="p-6 border-b border-gray-700">
        <h1 className="text-2xl font-bold text-center">P&M Admin</h1>
        <p className="text-xs text-gray-400 text-center mt-1">Dashboard</p>
      </div>


      {/* Navigation */}
      <nav className="mt-6">
        <Link
          to="/admin"
          className={`flex items-center px-6 py-3 text-gray-300 hover:bg-gray-800 hover:text-white transition-colors ${
            pathMatchRoute('/admin') && 'bg-gray-800 text-white border-r-4 border-blue-500'
          }`}
        >
          <FaChartBar className="mr-3" />
          Dashboard
        </Link>


        <Link
          to="/admin/properties"
          className={`flex items-center px-6 py-3 text-gray-300 hover:bg-gray-800 hover:text-white transition-colors ${
            pathMatchRoute('/admin/properties') && 'bg-gray-800 text-white border-r-4 border-blue-500'
          }`}
        >
          <FaHome className="mr-3" />
          Properties
        </Link>


        {/* NEW: Create Property Link */}
        <Link
          to="/create-listing"
          className={`flex items-center px-6 py-3 text-gray-300 hover:bg-gray-800 hover:text-white transition-colors ${
            pathMatchRoute('/create-listing') && 'bg-gray-800 text-white border-r-4 border-blue-500'
          }`}
        >
          <FaPlus className="mr-3" />
          Create Property
        </Link>


        <Link
          to="/admin/users"
          className={`flex items-center px-6 py-3 text-gray-300 hover:bg-gray-800 hover:text-white transition-colors ${
            pathMatchRoute('/admin/users') && 'bg-gray-800 text-white border-r-4 border-blue-500'
          }`}
        >
          <FaUsers className="mr-3" />
          Users
        </Link>


        <Link
          to="/admin/contacts"
          className={`flex items-center px-6 py-3 text-gray-300 hover:bg-gray-800 hover:text-white transition-colors ${
            pathMatchRoute('/admin/contacts') && 'bg-gray-800 text-white border-r-4 border-blue-500'
          }`}
        >
          <FaEnvelope className="mr-3" />
          Contact Forms
        </Link>
      </nav>


      {/* Bottom Section */}
      <div className="absolute bottom-0 w-full border-t border-gray-700">
        <button
          onClick={() => navigate('/')}
          className="flex items-center w-full px-6 py-3 text-gray-300 hover:bg-gray-800 hover:text-white transition-colors"
        >
          <FaCog className="mr-3" />
          Back to Site
        </button>
        <button
          onClick={onLogout}
          className="flex items-center w-full px-6 py-3 text-gray-300 hover:bg-gray-800 hover:text-red-400 transition-colors"
        >
          <FaSignOutAlt className="mr-3" />
          Logout
        </button>
      </div>
    </div>
  );
}
